// Copyright (c) 2025 Audere, All Rights Reserved

import { Link as RouterLink } from "react-router";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { theme } from "../../theme";
import { createStyleSheet } from "../utils/styles";
import AppLogo from "../../assets/HP_Logo.svg";
import { selectCurrentToken } from "../features/auth/authSlice";

const NotFound = () => {
  const { t } = useTranslation("NotFound");
  const isLoggedIn = !!useSelector(selectCurrentToken);

  return (
    <Box sx={styles.wrapper}>
      <Container maxWidth="md" sx={styles.container}>
        <Box component="img" src={AppLogo} alt="HealthPulse AI" />
        <Typography variant="h4" gutterBottom mt={1}>
          {t("errorCode")} {t("errorTitle")}
        </Typography>
        <Typography variant="body1" sx={styles.description}>
          {t("errorDescription")}
          <Box component={RouterLink} to="/" sx={styles.linkText}>
            {isLoggedIn ? t("ErrorPage:backHome") : t("ErrorPage:backToLogin")}
          </Box>
        </Typography>
      </Container>
    </Box>
  );
};

const styles = createStyleSheet({
  wrapper: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    bgcolor: "#fff",
  },
  container: {
    textAlign: "center",
  },
  description: {
    mb: 4,
  },
  linkText: {
    color: theme.palette.primary.main,
    textDecoration: "underline",
    cursor: "pointer",
    fontWeight: 500,
    ml: 1,
  },
});

export default NotFound;
